<script>
import Card from "@/pages/components/card.vue";
import {Link, useForm} from "@inertiajs/vue3";
import FormElements from "@wielink-application/shared/js/mixins/formElements";
import Menu from "@/pages/customers/_menu.vue"

let timeout = null;

export default {
	mixins: [FormElements],
	components: {Card, Link, Menu},
	data() {
		return {
			customerId: '',
			form: useForm({
				client_number: '',
				king_code: '',
				calibration_id: '',
				ki_number: '',
				work_order_id: '',
				name: '',
				email: '',
				contactperson: '',
				address: '',
				zipcode: '',
				city: '',
				country: '',
				phone: '',
				mobile: '',
				website: '',
				lat: '',
				lon: '',
				particularities: '',
				defaulter: '',
			})
		}
	},
	methods: {
		setCustomer(customer) {
			this.customerId = customer.id;

			this.form.defaults(Helpers.prepareFormDefaults(customer));
			this.form.reset();
		},

		getLatLon(type) {
			timeout ? clearTimeout(timeout) : null;
			timeout = setTimeout(() => {
				if (!this.form.isDirty || !this.form.address || !this.form.zipcode || !this.form.city || !this.form.country) {
					return;
				}

				$.ajax({
					url: route('api.v1.customers.latlon'),
					data: this.form.data(),
					success: (response) => {
						this.form.lat = response.data.lat;
						this.form.lon = response.data.lon;
					}
				})
			}, 200)
		}
	},

	mounted() {
		this.$watch('form.address', this.getLatLon.bind(this, 'address'));
		this.$watch('form.zipcode', this.getLatLon.bind(this, 'zipcode'));
		this.$watch('form.city', this.getLatLon.bind(this, 'city'));
		this.$watch('form.country', this.getLatLon.bind(this, 'country'));
	}
}
</script>

<template>
	<Menu :customer-id="customerId"/>

	<div class="row g-4 pb-4">
		<div class="col-xl-6">
			<Card class="h-100">
				<h2 class="card-title">Gegevens</h2>
				<p>Voer hier de gegevens van de klant in</p>

				<Input
					v-model="form.ki_number"
					:form="form"
					label="RDW Referentie"
					name="ki_number"
					disabled
				/>

				<Input
					v-model="form.client_number"
					:form="form"
					type="number"
					name="client_number"
					label="Klantennummer"
					required
				/>

        <Input
            v-model="form.king_code"
            :form="form"
            name="king_code"
            label="Klantennummer (King)"
            required
        />

				<Input
					v-model="form.name"
					:form="form"
					name="name"
					label="Naam"
				/>

				<FormGroup>
					<Checkbox
						v-model="form.calibration_id"
						:form="form"
						:checked="form.calibration_id"
						:value="1"
						name="calibration_id"
						label="Kalibratie"
						required
					/>
				</FormGroup>

				<Textarea
					v-model="form.particularities"
					:form="form"
					type="textarea"
					name="particularities"
					label="Bijzonderheden"
				/>

				<YesNo
					v-model="form.defaulter"
					:form="form"
					name="defaulter"
					label="Is dit bedrijf een wanbetaler?"
				/>
			</Card>
		</div>

		<div class="col-xl-6">
			<Card class="h-100">
				<h2 class="card-title">Adres</h2>
				<p>Voer hier de adres gegevens in</p>

				<Input
					v-model="form.address"
					:form="form"
					name="address"
					label="Adres"
					required
				/>

				<Input
					v-model="form.zipcode"
					:form="form"
					name="zipcode"
					label="Postcode"
					required
				/>

				<Input
					v-model="form.city"
					:form="form"
					name="city"
					label="Plaats"
					required
				/>

				<Input
					v-model="form.country"
					:form="form"
					name="country"
					label="Land"
					required
				/>

				<FormGroup>
					<div class="text">
						<p>Onderstaande velden zullen automatisch worden gevuld wanneer de adres gegevens ingevuld zijn.</p>

						<p>Als de velden niet automatisch gevuld kunnen worden kunt u onderstaande velden zelf vullen door het adres in te vullen op de volgende website:
							<a href="https://www.latlong.net/" target="_blank">www.latlong.net</a>
						</p>

						<p>
							Latitude = Breedtegraad <br>
							Longitude = Lengtegraad
						</p>

						<p>
							<strong>Wanneer deze velden niet gevuld zijn kunnen we ze niet aanbevelen bij het inplannen van afspraken.</strong>
						</p>
					</div>
				</FormGroup>

				<Input
					v-model="form.lat"
					:form="form"
					name="lat"
					label="Breedtegraad"
				/>

				<Input
					v-model="form.lon"
					:form="form"
					name="lon"
					label="Lengtegraad"
				/>
			</Card>
		</div>

		<div class="col-xl-6">
			<Card class="h-100">
				<h2 class="card-title">Contactgegevens</h2>
				<p>Voer hier de contact gegevens in</p>

				<Input
					v-model="form.email"
					:form="form"
					type="email"
					name="email"
					label="E-mail"
				/>

				<Input
					v-model="form.contactperson"
					:form="form"
					name="contactperson"
					label="Contactpersoon"
				/>

				<Input
					v-model="form.phone"
					:form="form"
					name="phone"
					label="Telefoon"
				/>

				<Input
					v-model="form.mobile"
					:form="form"
					name="mobile"
					label="Mobiel"
				/>

				<Input
					v-model="form.website"
					:form="form"
					name="website"
					label="Website"
				/>
			</Card>
		</div>
	</div>
</template>